module.exports = __webpack_public_path__ + "static/rede-mais-f5ee57d9e5f2cf2688352fb2e573b818.png";